import { render, staticRenderFns } from "./ReportBuyer.vue?vue&type=template&id=22484b00&scoped=true&"
import script from "./ReportBuyer.vue?vue&type=script&lang=js&"
export * from "./ReportBuyer.vue?vue&type=script&lang=js&"
import style0 from "./ReportBuyer.vue?vue&type=style&index=0&id=22484b00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22484b00",
  null
  
)

export default component.exports